export default {
  langs: [],
  title: '',
  schedule: {},
  districtId: '',
  collection: {},
  localityId: '',
  defaultLang: '',
  countryCode: '',
  selectedLang: '',
  webappConfig: {},
  districtLabel: '',
  templateColour: '',
  reminderOption: {},
  searchAtFirst: false,
  isMultiDistrict: false,
  isPromptMessageOpen: true,
  shouldSeeDistrictSelector: false,
};
